(function($) {
    var $fn = $(".part_form_order");

    if ($fn.length) {
        // -- SHIPPING -- //
        (function() {
            function fn_shipping_copy() {
                $fn.find("[data-billing-group] [data-shipping-id]").each(function(){
                    var $id = $(this).data("shipping-id"),
                        $val = $(this).val();
                    $fn.find('[data-shipping-group] [data-shipping-id="'+$id+'"]').val($val).attr("readonly",true).closest(".part_ui_input").addClass("mod--disabled");
                });
            }

            if ($fn.find("[data-shipping-switch]").prop("checked")) {
                fn_shipping_copy();
            }

            $fn.on("change","[data-shipping-switch]", function () {
                var $el = $(this);
                if ($el.prop("checked")) {
                    fn_shipping_copy();
                } else {
                    $fn.find("[data-shipping-group] [data-shipping-id]").each(function(){
                        $(this).val("").removeAttr("readonly").trigger("change").closest(".part_ui_input").removeClass("mod--disabled");
                    });
                }
            });

            $fn.on("change","[data-billing-group] [data-shipping-id]", function () {
                var $el = $(this);
                if ($fn.find("[data-shipping-switch]").prop("checked")) {
                    var $id = $el.data("shipping-id"),
                        $val = $el.val();
                    $fn.find('[data-shipping-group] [data-shipping-id="'+$id+'"]').val($val);
                }
            });
        })();
    }
})(jQuery);